module.exports = __webpack_public_path__ + "static/widerfunnel-logo-104fd925caab209afdfb3f71d716be8c.png";